import { Button, Modal } from '@mairistem/composants';
import React from 'react';
import type { BordereauWithState } from '../../../../../interfaces/pieces/TreeRow';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';

interface BordereauDenumeroterModalProps {
  onChange: (data: BordereauWithState) => void;
  onClose: VoidFunction;
  bordereau: BordereauWithState;
  visible: boolean;
  isSuperUser: boolean;
  isArchive: boolean;
}

const BordereauDenumeroterModal = ({
  onChange,
  onClose,
  bordereau,
  visible,
  isSuperUser,
  isArchive,
}: BordereauDenumeroterModalProps) => {
  const { isValidated, validationComponent } = useModalSuperUserValidation();
  return (
    <Modal
      open={visible}
      onClose={onClose}
      closeIcon
      data-testid="bordereauDenumeroterModal"
    >
      <Modal.Header>
        {
          isArchive ? `Annuler l'archivage de ce bordereau de rejet n°${bordereau.numero}` : `Dénuméroter le bordereau n°${bordereau.numero}`
        }
      </Modal.Header>
      <Modal.Content>
        <p>
          Cette action repositionne le bordereau dans les en-cours de saisie.
          Le bordereau perd sa numérotation définitive en vue de pouvoir remanier son contenu
          (ajout, modification ou suppression d&apos;écritures)
        </p>
        {isSuperUser && validationComponent}
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          data-testid="bordereauDenumeroterModalCancel"
        >
          Annuler
        </Button>
        <Button
          disabled={isSuperUser && !isValidated}
          primary
          onClick={
            () => {
              onChange(bordereau);
              onClose();
            }
          }
          data-testid="bordereauDenumeroterModalConfirm"
        >
          Confirmer
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default BordereauDenumeroterModal;
